import { elevatorIntegrationApi } from './elevatorIntegrationApi';

export type ElevatorIntegrationTagTypes = 'elevator-integration';
export const elevatorIntegrationApiEnhancer = elevatorIntegrationApi.enhanceEndpoints<ElevatorIntegrationTagTypes>({
  addTagTypes: ['elevator-integration'],
  endpoints: {
    getIntercomIntegrationStatusesEi: {
      providesTags: (_result, _error, { companyId, siteId }) => [
        {
          id: `${companyId}-${siteId}-intercom-integration-statuses`,
          type: 'elevator-integration',
        },
      ],
    },
    getSiteBuildingTopologyEi: {
      providesTags: (_result, _error, { companyId, siteId }) => [
        {
          id: `${companyId}-${siteId}`,
          type: 'elevator-integration',
        },
      ],
    },
    refreshSiteBuildingTopologyEi: {
      invalidatesTags: (_result, _error, { companyId, siteId }) => [
        {
          id: `${companyId}-${siteId}`,
          type: 'elevator-integration',
        },
      ],
    },
    updateSiteFloorMappingEi: {
      invalidatesTags: [{ id: 'floor-mapping', type: 'elevator-integration' }],
    },
  },
});
